import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';

export default function TransferenciaDetalleModalComponent({
  show = false,
  onHide = () => {},
  transferencia = null,
  tipo = 'aprobada' // 'aprobada' o 'rechazada'
}) {
  if (!show || !transferencia) return null;

  const isAprobada = tipo === 'aprobada';
  const titulo = isAprobada ? 'Detalle de Aprobación' : 'Detalle de Rechazo';
  const varianteBadge = isAprobada ? 'success' : 'danger';
  const estadoTexto = isAprobada ? 'APROBADA' : 'RECHAZADA';
  const iconoEstado = isAprobada ? 'check_circle' : 'cancel';
  const colorEstado = isAprobada ? '#28a745' : '#dc3545';

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{titulo}</Modal.Title>
      </Modal.Header>
      
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {/* Estado de la transferencia */}
        <Row className="mb-4">
          <Col xs={12}>
            <div className="text-center p-3 rounded" style={{ backgroundColor: '#f8f9fa', borderLeft: `4px solid ${colorEstado}` }}>
              <i className='material-icons' style={{ fontSize: '2.5rem', color: colorEstado, marginBottom: '0.5rem' }}>
                {iconoEstado}
              </i>
              <h4 style={{ color: colorEstado, marginBottom: '0' }}>
                Transferencia {estadoTexto}
              </h4>
            </div>
          </Col>
        </Row>

        {/* Información del Alumno y Gira */}
        <Row className="mb-4">
          <Col md={6}>
            <h5>Información del Alumno</h5>
            <div className="mb-2">
              <strong>Alumno:</strong> {`${transferencia.alu_nombres || ''} ${transferencia.alu_apellidos || ''}`.trim() || 'N/A'}
            </div>
            <div className="mb-2">
              <strong>Gira ID:</strong> {transferencia.gir_id || 'N/A'}
            </div>
          </Col>

          <Col md={6}>
            <h5>Información del Pago</h5>
            <div className="mb-2">
              <strong>Código:</strong> <code>{transferencia.trn_codigo}</code>
            </div>
            <div className="mb-2">
              <strong>Referencia de Pago:</strong> {transferencia.trn_referencia_pago || '-'}
            </div>
            <div className="mb-2">
              <strong>Fecha de Pago:</strong> {transferencia.trn_fecha_pago ? new Date(transferencia.trn_fecha_pago).toLocaleDateString('es-CL') : '-'}
            </div>
          </Col>
        </Row>

        {/* Montos */}
        <Row className="mb-4 p-3 bg-light rounded">
          <Col md={6}>
            <div className="mb-3">
              <strong>Monto del Pago:</strong>
              <div style={{ fontSize: '1.5rem', color: '#007bff', fontWeight: 'bold' }}>
                ${Number(transferencia.trn_monto).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
              </div>
            </div>
          </Col>

          {transferencia.trn_multa > 0 && (
            <Col md={6}>
              <div className="mb-3">
                <strong>Multa Aplicada:</strong>
                <div style={{ fontSize: '1.5rem', color: '#dc3545', fontWeight: 'bold' }}>
                  ${Number(transferencia.trn_multa).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                </div>
              </div>
            </Col>
          )}
        </Row>

        {/* Observación/Comentario */}
        <Row className="mb-4">
          <Col xs={12}>
            <h5>Observación</h5>
            <div className="p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '0.5rem', borderLeft: `4px solid ${colorEstado}`, minHeight: '100px' }}>
              {transferencia.trn_comentario_admin ? (
                <p style={{ margin: '0', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {transferencia.trn_comentario_admin}
                </p>
              ) : (
                <p style={{ margin: '0', color: '#6c757d', fontStyle: 'italic' }}>
                  No hay observación registrada
                </p>
              )}
            </div>
          </Col>
        </Row>

        {/* Información adicional */}
        <Row className="mb-3 border-top pt-3">
          <Col md={6}>
            <small className="text-muted">
              <strong>Fecha de {isAprobada ? 'Aprobación' : 'Rechazo'}:</strong> <br />
              {transferencia.trn_fecha_actualizacion 
                ? new Date(transferencia.trn_fecha_actualizacion).toLocaleString('es-CL')
                : '-'
              }
            </small>
          </Col>
          <Col md={6}>
            <small className="text-muted">
              <strong>Estado:</strong> <br />
              <span className={`badge bg-${varianteBadge}`}>
                {estadoTexto}
              </span>
            </small>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
